module.exports = __webpack_public_path__ + "img/231711000-1.407ebcbd.png";